import { trackEvent } from "@adsk/acc-issues-core/utils/analytics/trackEvent";
import {
  IssueFilterApplyAnalyticsEvent,
  IssueFilterOpenAnalyticsEvent,
  IssueSortApplyAnalyticEvent,
  IssueFilterClearAllAnalyticsEvent,
  IssueFilterResetAnalyticsEvent,
} from "./analyticsLib093IssuesEvents";

//  name: "issue.filter.apply"
//  description: "The user applies a filter"
export const trackFilterApply = ({
  field,
  fieldValue,
}: ConstructorParameters<typeof IssueFilterApplyAnalyticsEvent>[0]) => {
  trackEvent(new IssueFilterApplyAnalyticsEvent({ field, fieldValue }));
};

export const trackClearAllFilters = () => {
  trackEvent(new IssueFilterClearAllAnalyticsEvent());
};

export const trackResetFilters = () => {
  trackEvent(new IssueFilterResetAnalyticsEvent());
};

export const trackFilterOpen = () => {
  trackEvent(new IssueFilterOpenAnalyticsEvent());
};

export const trackSortApply = (sortBy: string, order: string) => {
  trackEvent(new IssueSortApplyAnalyticEvent({ sortBy, order }));
};
